import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import '../styles/shared/Header.css'
import { Navbar, Container, Nav, Image } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import logo from '../assests/SA BLU.png'
import useScrolled from '../hooks/useScrolled'

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact Us' },
]

const Header = () => {
  const [expanded, setExpanded] = useState(false)
  const scrolled = useScrolled(16)

  const close = useCallback(() => setExpanded(false), [])

  // There used to be a single highlight that measured each item and slid
  // between them. It kept stranding an ink-coloured label on top of a navy
  // block — whenever it was measured before layout settled, and again whenever
  // the pointer sat between two items. Hover is now plain CSS on each link, so
  // the label and the thing behind it can no longer disagree.

  // Publish the header's real height so every page can reserve exactly that
  // much room. The bar's height changes with breakpoint, scroll state and
  // font loading, so a hard-coded token always drifts out of date.
  useLayoutEffect(() => {
    const bar = document.querySelector('.header')
    if (!bar) return

    const publish = () => {
      const h = Math.round(bar.getBoundingClientRect().height)
      if (h > 0) {
        document.documentElement.style.setProperty('--header-h', `${h}px`)
      }
    }

    publish()

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', publish)
      return () => window.removeEventListener('resize', publish)
    }

    const ro = new ResizeObserver(publish)
    ro.observe(bar)
    return () => ro.disconnect()
  }, [])

  // Hold the page still while the mobile sheet is open
  useEffect(() => {
    if (!expanded) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [expanded])

  // Close the sheet on Escape
  useEffect(() => {
    if (!expanded) return
    const onKey = (e) => {
      if (e.key === 'Escape') close()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [expanded, close])

  return (
    <>
      <Navbar
        className={`header${scrolled ? ' header--scrolled' : ''}${expanded ? ' header--open' : ''}`}
        collapseOnSelect
        expand="lg"
        fixed="top"
        expanded={expanded}
      >
        <Container className="header__bar">
          <Navbar.Brand className="header__brand">
            <NavLink to="/" onClick={close} aria-label="42 Card Solutions">
              <Image src={logo} alt="42 Card Solutions" />
            </NavLink>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            aria-label="Menu"
            onClick={() => setExpanded(expanded ? false : 'expanded')}
          >
            <span className="header__burger" aria-hidden="true">
              <i />
              <i />
              <i />
            </span>
          </Navbar.Toggle>

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto header__nav">
              {NAV_ITEMS.map(({ to, label }, i) => (
                <Nav.Link as="div" key={to} style={{ '--i': i }}>
                  <NavLink
                    exact
                    to={to}
                    className="main-nav"
                    activeClassName="main-nav-active"
                    onClick={close}
                  >
                    {label}
                  </NavLink>
                </Nav.Link>
              ))}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Dimmer behind the mobile sheet */}
      <div
        className={`header__scrim${expanded ? ' is-open' : ''}`}
        onClick={close}
        aria-hidden="true"
      />
    </>
  )
}

export default Header
